// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { queryClient } from '@/lib/react-query';

const deleteClosureRequest =
  ({ partnerId, makeRequest }: { partnerId: string; makeRequest: any }) =>
  async (): Promise<void> => {
    const { error } = await makeRequest({
      path: `/partners/${partnerId}/closure-request`,
      method: 'delete',
    });

    if (error) {
      throw new Error(error);
    }
  };

export const useDeletePartnerClosureRequest = () => {
  const { id: partnerId } = useParams() as { id: string };

  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useMutation({
    mutationFn: deleteClosureRequest({ partnerId, makeRequest }),
    onSuccess: () => {
      // Reset the cache for the closure request
      queryClient.refetchQueries({
        queryKey: ['partners', partnerId, 'closure-request'],
      });
    },
  });
};
